import { render, staticRenderFns } from "./StreamPage.vue?vue&type=template&id=d871f3b2&scoped=true&"
import script from "./StreamPage.vue?vue&type=script&lang=js&"
export * from "./StreamPage.vue?vue&type=script&lang=js&"
import style0 from "./StreamPage.vue?vue&type=style&index=0&id=d871f3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d871f3b2",
  null
  
)

export default component.exports